import {Controller} from "../controller";

export class LandingApps extends Controller {
    /* INSTANCE */
    public static override async build(): Promise<void> {
        LandingApps.enableClickOverTextsMV();

        let container:any = document.querySelector("#texts-container");

        // Obtiene todos los elementos <li> dentro del contenedor de textos
        let listItems = document.querySelectorAll("#text-list .row");

        // Agrega eventos de ratón a cada elemento de la lista
        listItems.forEach((item, index) => {
            item.addEventListener("mouseover", () => {
                LandingApps.changeImage(index + 1); // El índice empieza desde 0, pero tus IDs empiezan desde 1
                if(index==4) {
                    container.style.maskImage = 'linear-gradient(to top, transparent 0%, white 5%)';
                }
            });
        });

        // Función para cambiar la altura del contenedor en función de la posición del ratón
        let minH = 0;
        container.addEventListener("mousemove", (event:any) => {
            let containerRect = container.getBoundingClientRect();
            let mouseY = event.clientY - containerRect.top; // Posición del ratón relativa al contenedor
            minH = minH < mouseY ? mouseY : minH;
            container.style.height = 150 + minH + 'px';
        });
    }
    public static changeImage(index:number){
        let ulImages:any = document.getElementById('images-slider');
        let ulTexts:any = document.getElementById('text-list');
        if(ulImages && ulTexts){
            let images:HTMLElement[] = ulImages.getElementsByTagName('img');
            for (let image of images){
                image.classList.remove('active');
            }
            let texts:HTMLElement[] = ulTexts.getElementsByTagName('li');
            for (let text of texts){
                text.classList.remove('active');
            }
        }
        let image = document.getElementById('image-'+index);
        if(image) {
            image.classList.add('active');
        }
        let text = document.getElementById('text-'+index);
        if(text) {
            text.classList.add('active');
        }
    }

    public static changeImageMV(index:number){
        let ulImages:any = document.getElementById('images-slider');
        let ulTexts:any = document.getElementById('text-list');
        if(ulImages && ulTexts){
            let images:HTMLElement[] = ulImages.getElementsByTagName('li');
            for (let image of images){
                image.classList.remove('active');
            }
            let texts:HTMLElement[] = ulTexts.getElementsByTagName('li');
            for (let text of texts){
                text.classList.remove('active');
            }
        }
        let image = document.getElementById('image-'+index);
        if(image) {
            image.classList.add('active');
        }
        let text = document.getElementById('text-'+index);
        if(text) {
            text.classList.add('active');
        }
    }

    public static enableClickOverTextsMV(){
        let ulImages:any = document.getElementById('images-slider');
        let elements = ulImages.getElementsByClassName('col-n');
        for (let element of elements){
            element.onclick = () => {
                let id:any = element.id.split('-')[1];
                if(id)
                    this.changeImageMV(id);
            };
        }
    }
}
